import React, { Component } from 'react'
import { connect } from 'react-redux'
import { signUp } from '../../redux/actions/AuthActions'
import { Redirect } from 'react-router-dom'

class SignUp extends Component {
    state = {
        email: '',
        password: '',
        firstName: '',
        lastName: '',
        phone: ''
    }

    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        })
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.signUp(this.state);
    }

    render() {
        const {authError, auth} = this.props;
        if (auth.uid) return <Redirect to='/trips' />;
        return (
            <div className='container-fluid col-md-4'>
                <div className='text-center'>
                    <i class="fas fa-car fa-7x"></i>
                    <br />
                </div>
                <form onSubmit={this.handleSubmit}>
                    <div className='form-group'>
                        <label htmlFor='email'>Email Address</label>
                        <input type='email' class='form-control' id='email' onChange={this.handleChange} />
                    </div>
                    <div className='form-group'>
                        <label htmlFor='password'>Password</label>
                        <input type='password' class='form-control' id='password' onChange={this.handleChange} />
                    </div>
                    <div className='form-group'>
                        <label htmlFor='firstName'>First Name</label>
                        <input type='text' class='form-control' id='firstName' onChange={this.handleChange} />
                    </div>
                    <div className='form-group'>
                        <label htmlFor='lastName'>Last Name</label>
                        <input type='text' class='form-control' id='lastName' onChange={this.handleChange} />
                    </div>
                    <div className='form-group'>
                        <label htmlFor='phone'>Phone Number</label>
                        <input type='tel' class='form-control' id='phone' pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}" onChange={this.handleChange} />
                    </div>
                    <div className='text-center'>
                        <button className='btn btn-info text-center'>Sign Up</button>
                    </div>
                </form>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        // Root State -> Auth -> authError
        // store/reducers/AuthReducer
        authError: state.auth.authError,
        auth: state.firebase.auth
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        signUp: (creds) => dispatch(signUp(creds))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SignUp)